import { SendOrgMemberInvitationRequestSchema, SendOrgMemberInvitationResponseSchema } from './send-org-member-invitation.schema';
/**
 * Send Org Member Invitation Endpoint Contract
 * Sends an invitation email to an inactive organization member
 */ export const sendOrgMemberInvitationContract = {
    method: 'POST',
    path: '/api/v2/org-member/:id/send-invitation',
    description: 'Send invitation email to an inactive organization member',
    requestSchema: SendOrgMemberInvitationRequestSchema,
    responseSchema: SendOrgMemberInvitationResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - user is not inactive',
            401: 'Unauthorized - user not authenticated',
            404: 'Not Found - organization member not found'
        }
    }
};

//# sourceMappingURL=send-org-member-invitation.contract.js.map